<template>
  <div id="terms" class="container-fluid px-0">
    <div class="main no-side-bar">
      <nav v-if="$store.state.user.authenticated">
        <TopNav></TopNav>
        <MobileNav></MobileNav>
      </nav>
      <header class="page-header bg-brand-secondary">
        <div class="content-container container">
          <div class="page-title col-12">
            <h3>{{ componentText.title }}</h3>
          </div>
        </div>
      </header>
      <main class="content-wrap">
        <div class="content-container row py-5">
          <div role="document" class="content-card w-100 p-5">
            <div class="content-inner p-md-5 m-md-5 p-0 m-0" v-html="decodeData(content)"></div>
            <div class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                mt-5
                brand-text
              " v-if="!this.$store.getters.user.user.tc_accepted && $store.state.user.authenticated">

              <div class="d-flex flex-row align-items-center mb-4">
                <input
                  type="checkbox"
                  id="agree-checkbox"
                  v-model="checkbox"
                  aria-label="Agree to terms and conditions"
                  class="checkbox"
                />
                <label for="agree-checkbox" class="ml-2">
                  I have read and agree to the above terms and conditions.
                </label>
              </div>

              <b-button
                class="cta-button px-5 pt-3 pb-4"
                :disabled="!checkbox"
                @click="agreeToTCs()"
                aria-label="Agree to terms and conditions"
              >
                <span v-if="agreementSuccess === false">Agree!</span>
                <span v-else>Success!</span>
              </b-button>
            </div>
            <div v-else-if="agreementSuccess" class="d-flex justify-content-center">
              <p class="brand-text">
                You have successfully agreed to the terms and conditions, you'll
                be redirectly shortly..
              </p>
            </div>
          </div>
        </div>
      </main>
      <footer v-if="$store.state.user.authenticated">
        <Footer></Footer>
      </footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import TopNav from "@/components/TopNav.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "../components/Footer";
export default {
  name: "TCs",
  components: {
    Footer,
    TopNav,
    MobileNav,
  },
  data() {
    return {
      agreementSuccess: false,
      checkbox: false,
      content: "",
      isLoading: true,
    };
  },
  mounted() {
    if (this.$route.query.lang) {
      this.$store.commit("setLanguage", this.$route.query.lang);
    }
    this.getTCS();
  },
  methods: {
    toggleCheckbox() {
      this.checkbox = !this.checkbox;
    },
    async agreeToTCs() {
      if (this.checkbox) {
        const payload = {
          user_id: this.$store.getters.user_id,
          terms_type: ["tc"],
        };
        let res = await axios.post(
          config.api_env + "/application/api/u/user/accept-terms",
          payload,
          config.options
        );
        if (res.data.success) {
          let self = this;
          this.$store.dispatch("setUserTermsAgreementTrue");
          this.agreementSuccess = true;
          setTimeout(function () {
            // Honour redirect_to from /loginas — see LoginAs.vue.
            const target = sessionStorage.getItem("postLoginRedirect") || "/";
            self.$router.push(target);
          }, 2000);
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login").catch((err) => { });
        }
      }
    },
    decodeData(data) {
      try {
        return Buffer.from(data, "base64");
      } catch (error) {
        return data;
      }
    },
    async getTCS() {
      let slug = this.$store.getters.user.user_tc_slug;
      if (slug === 'generic_tc' && this.$store.getters.client.tc_slug) {
        slug = this.$store.getters.client.tc_slug
      }
      if (this.$route.params.slug) {
        slug = this.$route.params.slug;
      }
      const payload = {
        slug,
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/info/get-info",
        payload,
        config.options
      );
      if (res.data.success) {
        this.content = res.data.dynamic_string.string;
        this.isLoading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login").catch((err) => { });
      }
    },
  },
  computed: {
    componentText() {
      return this.getText.terms;
    },
  },
  watch: {
    skin(newVal) {
      this.$store.commit("setSkin", newVal);
    },
  },
};
</script>
<style lang="less">
#terms {
  font-size: 1.6rem;
  font-family: "DMSans", sans-serif;
  letter-spacing: normal;
  color: #122130;

  table {
    width: 100% !important;
  }

  ul {
    list-style-type: decimal;
  }

  p, span, h4 {
    color: #122130 !important;
    letter-spacing: normal;
    font-weight: normal !important;
  }

  p, span {
    font-family: "DMSans", sans-serif !important;
    color: #122130;
  }

  h1, h2, h3, h4 {
    font-family: "Raptor V3 Black";
    letter-spacing: normal;
    font-size: 2.6rem;
    color: #122130;
    margin: 20px 0;
  }

  h3 {
    padding: 0 !important;
  }

  section {
    margin-bottom: 0;
  };

  .page-header {
    padding: 60px 0;
  }

  .page-title {
    text-align: left;

    h3 {
      text-align: left;
      font-size: 3.8rem;
      letter-spacing: normal;
      color: #fff;
    }
  }

  .content-wrap {
    background: #f4f4f4;
    white-space: normal;

    .content-card {
      transform: translateY(-80px);
      background: #ffffff;
      max-width: 1000px;
      margin: auto;

      h4 {
        margin-bottom: 20px;
      }
    }
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border: 2px solid #3a4961;
    margin-right: 8px;
  }

  tbody {
    vertical-align: baseline;
  }

  td {
    padding: 8px;
    border: 1px solid black;
  }

  label {
    margin-bottom: 0;
  }

  .content-inner {
    overflow: scroll;
  }

  @media (max-width: 992px) {
    .page-header {
      padding-top: 100px;
    }

    .content-card {
      transform: translateY(0);
    }
  }

  p.brand-text {
    text-align: center;
    font-size: 1.6rem;
    font-weight: bold;
    max-width: 500px;
  }
}
</style>
